<template>
  <div class="location-search__map">
    <div class="location-search__actions-container">
      <button class="button" v-on:click="searchCurrentViewport">Update Search</button>
    </div>
    <gmap-map
      ref="mapRef"
      :center="defaultCenter"
      :zoom="3"
      :options="mapOptions"
      :style="mapStyle"
      @dragend="setMapMoved"
      @bounds_changed="setBounds"
    >
      <gmap-info-window
        :options="infoWindow.options"
        :position="infoWindow.position"
        :opened="infoWindow.open"
        @closeclick="closeInfoWindow"
      >
        <info-window-content :data="infoWindow.content"></info-window-content>
      </gmap-info-window>
      <gmap-marker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :icon="(locationTypes.includes(m.content.types[0])) ? markerPath+'map-marker-'+m.content.types[0].toLowerCase()+'.png' : markerPath+'map-marker-default.png'"
        :clickable="true"
        :draggable="false"
        @click="openInfoWindow(m, index)"
      />
    </gmap-map>
  </div>
</template>

<script>
  import { gmapApi } from 'vue2-google-maps'
  import infoWindowContent from './InfoWindowContent'

  export default {
    components: { infoWindowContent },
    props: {
      mapOptions: {
        type: Object,
        default: () => {
          return {
            maxZoom: null,
            minZoom: 3,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false
          }
        }
      },
      defaultCenter: {
        type: Object,
        default() {
          return {
            lat: 39.8097343,
            lng: -98.5556199
          }
        }
      },
      markers: {
        type: Array,
        required: true
      },
      mapStyle: {
        type: String,
        default: 'width: 100%;'
      },
      locationTypes: {
        type: Array,
        default: []
      },
    },
    mounted() {
    //   this.$refs.mapRef.$mapPromise.then(map => {
    //     let bounds = new this.google.maps.LatLngBounds();
    //     for (let marker of this.markers) {
    //       bounds.extend({
    //         lat: marker.position.lat,
    //         lng: marker.position.lng
    //       })
    //     }
    //     map.fitBounds(bounds);
    //   })
    },
    computed: {
      google: gmapApi,
      markerPath() {
        return 'https://d3rbut1q05o0is.cloudfront.net/images/';
        // return window.winebowLocatorConfig && window.winebowLocatorConfig.assetPath ? window.winebowLocatorConfig.assetPath + 'images/' : 'images/';
      },
      searchBounds() {
        return this.$store.state.bounds;
      }
    },
    data() {
      return {
        bounds: {
          ne: {
            lat: null,
            lng: null
          },
          sw: {
            lat: null,
            lng: null
          }
        },
        infoWindow: {
          content: {
            body: '',
            title: ''
          },
          currentIndex: null,
          open: false,
          options: {
            pixelOffset: {
              height: -35,
              width: 0
            }
          }
        },
        mapMoved: false
      }
    },
    methods: {
      closeInfoWindow() {
          this.infoWindow.open = false
      },
      fitBounds() {
          if (!this.google || !this.markers.length) {
            return
          }
          let bounds = new this.google.maps.LatLngBounds();
          for (let marker of this.markers) {
            bounds.extend({
              lat: marker.position.lat,
              lng: marker.position.lng
            })
          }
          this.$refs.mapRef.fitBounds(bounds);
      },
      setSearchBounds() {
          let bounds = new this.google.maps.LatLngBounds();
          bounds.extend({
            lat: this.searchBounds.ne.lat,
            lng: this.searchBounds.ne.lng
          });
          bounds.extend({
            lat: this.searchBounds.sw.lat,
            lng: this.searchBounds.sw.lng
          });
          this.$refs.mapRef.fitBounds(bounds);
      },
      openInfoWindow(marker, index) {
        this.handleInteractions()
        this.infoWindow.position = marker.position
        this.infoWindow.content = marker
        //check if its the same marker that was selected if yes toggle
        if (this.infoWindow.currentIndex == index) {
          this.infoWindow.open = !this.infoWindow.open
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWindow.open = true
          this.infoWindow.currentIndex = index
        }
      },
      handleInteractions() {
        //   this.$emit('interaction')
      },
      searchCurrentViewport() {
        let bounds = this.$refs.mapRef.$mapObject.getBounds()
        let southWest = bounds.getSouthWest()
        let northEast = bounds.getNorthEast()
        bounds = {
          sw: {
            lat: southWest.lat(),
            lng: southWest.lng()
          },
          ne: {
            lat: northEast.lat(),
            lng: northEast.lng()
          }
        }
        this.$store.dispatch("setBounds", bounds);
      },
      setBounds() {
        let bounds = this.$refs.mapRef.$mapObject.getBounds()
        let southWest = bounds.getSouthWest()
        let northEast = bounds.getNorthEast()
        this.bounds = {
          sw: {
            lat: southWest.lat(),
            lng: southWest.lng()
          },
          ne: {
            lat: northEast.lat(),
            lng: northEast.lng()
          }
        }
      },
      setMapMoved() {
        //   this.mapMoved = true
        //   this.handleInteractions()
      }
    },
    watch: {
      'markers': function() {
        this.closeInfoWindow();
        if (this.$props.markers.length > 0) {
          this.fitBounds();
        } else {
          this.setSearchBounds();
        }
      }
    }
  }
</script>
